import { api } from '../core';
import { CHRONOLOGY_TAG, CHRONOLOGY_UNDO_REDO_HISTORY_TAG } from '../constants';

export interface ChronologyEntriesSlotInRequest {
  caseId: string;
  entryIds: string[];
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ChronologyEntriesSlotInResponse {}

const chronologyEntriesSlotInApi = api.injectEndpoints({
  endpoints: (builder) => ({
    slotInChronologyEntries: builder.mutation<ChronologyEntriesSlotInResponse, ChronologyEntriesSlotInRequest>({
      query: (body: ChronologyEntriesSlotInRequest) => ({
        url: `/chronology/entries/slot-in`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (_result, _err, { caseId }) => [
        { type: CHRONOLOGY_TAG, id: caseId },
        { type: CHRONOLOGY_UNDO_REDO_HISTORY_TAG, id: caseId },
      ],
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useSlotInChronologyEntriesMutation } = chronologyEntriesSlotInApi;
